export default __webpack_public_path__ + "static/media/mastercard.7b7a23b4.png";